export enum RenovationProgram {
    UNKNOWN = 0,
    HAS_ANY = 1,
}
